export default "__VITE_ASSET__2I7$IygC__"